import { FormControl, TextField, Select, MenuItem, InputLabel, Input, Link, InputAdornment, OutlinedInput, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { alpha, styled } from '@mui/material/styles';

import { visuallyHidden } from '@mui/utils';

import React, { useEffect, useState } from 'react';

import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { AiOutlineSearch } from 'react-icons/ai';

import type { PageInfo } from '@/generated/graphql';

import { ChangePageType } from '@/shared/enums';

import type {
  IPlayerBalanceAdditionTable,
  IPlayerBalanceWithdrawalQueryVariable,
  IPlayerBalanceWithdrawalTable,
} from '@/shared/interfaces';

import type { SetStateAction } from 'react';

// components
import { TableBodySkeleton } from '@/components/table/table-body-skeleton';

type Order = 'asc' | 'desc';

interface TablePageLabel {
  start: number;
  end: number;
}

interface EnhancedTableProps {
  numSelected: number;
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof IPlayerBalanceWithdrawalTable) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

interface HeadCell {
  id: keyof IPlayerBalanceWithdrawalTable;
  label: string;
  numeric: boolean;
  className: string;
}

const headCells: readonly HeadCell[] = [
  {
    id: 'playerName',
    label: 'Player Name',
    numeric: false,
    className: '',
  },
  {
    id: 'cashierName',
    label: 'Cashier Name',
    numeric: false,
    className: '',
  },
  {
    id: 'receiverAccountNumber',
    label: 'Player account number',
    numeric: false,
    className: '',
  },
  {
    id: 'transactionType',
    label: 'Transaction Type',
    numeric: false,
    className: '',
  },
  {
    id: 'amountDisplay',
    label: 'Amount',
    numeric: true,
    className: '',
  },
  {
    id: 'createdAt',
    label: 'Created On',
    numeric: false,
    className: '',
  },
];

const StyledTableRow = styled(TableRow)(({}) => ({
  '& .MuiTableCell-root': {
    fontFamily: 'Open Sans,Roboto',
    fontWeight: 600,
    fontSize: 15,
    pt: 15,
    pb: 15,
    pl: 15,
  },
  '& .MuiTableCell-hover	': {
    backgroundColor: '#C2DAF0',
    border: '0.08em solid #C2DAF0',
  },

  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property: keyof IPlayerBalanceWithdrawalTable) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead sx={{ borderBottom: '0.08em solid #ccc', boxShadow: '0em 0.18em 0.4em #bbb' }}>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={index}
            align={headCell.numeric ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ fontWeight: '600', lineHeight: '1.2', color: '#555' }}
            className={headCell.className}
            sx={{ pl: 2, py: 1 }}>
            {headCell.label}
          </TableCell>
        ))}
        <TableCell
          className="actionColumn"
          style={{ fontWeight: '600', lineHeight: '1.2', color: '#555' }}
          key={'action'}
          align={'left'}
          padding={'normal'}>
          Action
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const { numSelected, searchHandler } = props;

  const [searchWord, setSearchWord] = useState<string>();

  const searchWordChanges = (value: React.SetStateAction<string | undefined>) => {
    if (value?.length === 0 && searchWord && searchWord.length > 0) {
      searchHandler('');
    }
    setSearchWord(value);
  };

  return (
    <Toolbar
      sx={{
        backgroundColor: '#6591BD',
        color: '#FFFFFF',
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}>
      <Typography sx={{ flex: '1 1 100%' }} variant="h6" id="tableTitle" component="div"></Typography>

      <FormControl sx={{ m: 1, width: '30ch' }} variant="standard">
        <InputLabel htmlFor="standard-adornment-search">Search</InputLabel>
        <Input
          id="standard-adornment-search"
          onChange={(e) => {
            searchWordChanges(e.target.value);
          }}
          onKeyDown={(event) => event.key === 'Enter' && searchHandler(searchWord ? searchWord : '')}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={(e) => searchHandler(searchWord ? searchWord : '')}
                // onMouseDown={handleMouseDownPassword}
              >
                {/* {showPassword ? <VisibilityOff /> : <Visibility />} */}
                <AiOutlineSearch />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>

      {/* <FormControl sx={{ ml: 2, mb: 2, mt: 1, width: 300 }}>
        <StyledTextField
          onChange={(e) => {
            searchHandler(e.target.value);
          }}
          id="filled-search"
          label="Search field"
          type="search"
          variant="outlined"
          size="small"
        />
      </FormControl> */}
    </Toolbar>
  );
};
interface lPlayerBalanceWithdrawalsProps {
  rows: readonly IPlayerBalanceWithdrawalTable[];
  setPlayerBalanceWithdrawalQueryVariable: React.Dispatch<SetStateAction<IPlayerBalanceWithdrawalQueryVariable>>;
  playerBalanceWithdrawalQueryVariable: IPlayerBalanceWithdrawalQueryVariable;
  totalCount: number;
  pageInfo: PageInfo | undefined;
  getPlayerBalanceWithdrawalLoading: boolean;
  transactionAction: (
    actionType: string,
    type: 'addition' | 'withdrawal',
    id: string,
    addition?: IPlayerBalanceAdditionTable,
    withdrawal?: IPlayerBalanceWithdrawalTable,
  ) => void;
}

interface EnhancedTableToolbarProps {
  numSelected: number;
  searchHandler: (value: string) => void;
}

export function TablePlayerBalanceWithdrawals(props: lPlayerBalanceWithdrawalsProps) {
  const navigate = useNavigate();

  const {
    rows,
    playerBalanceWithdrawalQueryVariable,
    setPlayerBalanceWithdrawalQueryVariable,
    totalCount,
    pageInfo,
    getPlayerBalanceWithdrawalLoading,
    transactionAction,
  } = props;
  const [search, setSearch] = useState('');

  const [order, setOrder] = useState<Order>('asc');
  const [orderBy, setOrderBy] = useState<keyof IPlayerBalanceWithdrawalTable>('createdAt');
  const [selected, setSelected] = React.useState<string[]>([]);
  const [page] = useState(0);
  const [dense] = useState(true);
  const [rowsPerPage] = useState(5);
  const [pageLabel, setPageLabel] = useState<TablePageLabel>({
    start: 1,
    end: playerBalanceWithdrawalQueryVariable.first,
  });

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof IPlayerBalanceWithdrawalTable) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const isSelected = (name: string) => selected.indexOf(name) !== -1;

  const searchHandler = (value: string) => {
    setSearch(value);

    setPlayerBalanceWithdrawalQueryVariable({
      ...playerBalanceWithdrawalQueryVariable,
      filterBy: {
        ...playerBalanceWithdrawalQueryVariable.filterBy,
        search: value,
      },
    });
  };

  const handleChangePage = (type: ChangePageType) => {
    if (type === ChangePageType.NEXT && pageInfo?.endCursor) {
      // next
      setPlayerBalanceWithdrawalQueryVariable({
        ...playerBalanceWithdrawalQueryVariable,
        after: pageInfo.endCursor,
        before: undefined,
      });
      let end = pageLabel.end + playerBalanceWithdrawalQueryVariable.first;
      if (end > totalCount) {
        end = totalCount;
      }
      setPageLabel({ start: pageLabel.start + playerBalanceWithdrawalQueryVariable.first, end });
    } else if (type === ChangePageType.PREV && pageInfo?.startCursor) {
      // prev
      setPlayerBalanceWithdrawalQueryVariable({
        ...playerBalanceWithdrawalQueryVariable,
        before: pageInfo.startCursor,
        after: undefined,
      });
      let end = pageLabel.end - playerBalanceWithdrawalQueryVariable.first;
      if (end > totalCount) {
        end = totalCount;
      }
      setPageLabel({ start: pageLabel.start - playerBalanceWithdrawalQueryVariable.first, end });
    }
  };

  const handleChangeRowsPerPage = (value: string | number) => {
    const intValue = parseInt(value.toString(), 10);

    setPlayerBalanceWithdrawalQueryVariable({
      ...playerBalanceWithdrawalQueryVariable,
      first: intValue,
    });
  };

  const goToPlayerBalanceWithdrawalPage = (id: string) => {
    navigate(`/dashboard/playerBalanceWithdrawals/${id}`);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  return (
    <Box sx={{ width: '100%', mt: 3 }}>
      <Paper
        sx={{
          width: '100%',
          mb: 2,
          backgroundColor: '#ffffff',
        }}>
        <EnhancedTableToolbar numSelected={selected.length} searchHandler={searchHandler} />
        <TableContainer>
          <Table
            sx={{
              minWidth: 850,
            }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}>
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            {getPlayerBalanceWithdrawalLoading ? (
              <TableBodySkeleton row={10} column={7} />
            ) : (
              <TableBody>
                {rows.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <StyledTableRow
                      // hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}>
                      <TableCell align="left">{row.playerName}</TableCell>
                      <TableCell align="left">{row.cashierName}</TableCell>
                      <TableCell align="left">{row.receiverAccountNumber}</TableCell>
                      <TableCell align="left">{row.transactionType}</TableCell>
                      <TableCell align="right">{row.amountDisplay}</TableCell>
                      <TableCell align="left">{row.createdAt}</TableCell>
                      <TableCell align="left">
                        {row.cashierId.length <= 0 ? (
                          <Button
                            onClick={() => transactionAction('assign to me', 'withdrawal', row.id, undefined, row)}
                            variant="contained"
                            size="small"
                            sx={{ textTransform: 'unset', fontSize: '10px' }}>
                            Assign to me
                          </Button>
                        ) : (
                          <Button
                            onClick={() => transactionAction('confirm', 'withdrawal', row.id, undefined, row)}
                            variant="contained"
                            color="success"
                            size="small"
                            sx={{ textTransform: 'unset', fontSize: '10px' }}>
                            Confirm
                          </Button>
                        )}
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Box
          sx={{
            backgroundColor: '#6591BD',
            color: '#FFFFFF',
            mt: 1,
            justifyContent: 'end',
            alignItems: 'center',
            display: 'flex',
          }}>
          <Typography variant="body2" mr={4} gutterBottom>
            Rows per page:
          </Typography>
          <FormControl variant="standard" sx={{ m: 1, minWidth: 50 }}>
            <Select
              onChange={(e) => {
                handleChangeRowsPerPage(e.target.value);
              }}
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={playerBalanceWithdrawalQueryVariable.first}
              label="Row">
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
          <Typography variant="body2" mx={4} gutterBottom>
            {pageLabel.start} - {pageLabel.end} of {totalCount}
          </Typography>
          <IconButton
            onClick={() => handleChangePage(ChangePageType.PREV)}
            disabled={pageInfo?.hasPreviousPage ? false : true}
            size={'small'}
            sx={{ mr: 2 }}
            aria-label="prev">
            <IoIosArrowBack />
          </IconButton>
          <IconButton
            onClick={() => handleChangePage(ChangePageType.NEXT)}
            disabled={pageInfo?.hasNextPage ? false : true}
            size={'small'}
            aria-label="next">
            <IoIosArrowForward />
          </IconButton>
        </Box>
      </Paper>
    </Box>
  );
}
